// Tema Claro/Escuro (Pacote de Correções, item 4) — preferência de
// VISUALIZAÇÃO do usuário, um conceito diferente de Personalização (que é a
// identidade/marca do tenant, ver branding.js). Mecanismo escolhido:
// localStorage, decisão documentada — é uma preferência pessoal de
// navegador, sem necessidade de sincronizar entre dispositivos, e a
// arquitetura atual não tem (nem este pacote deveria criar) um endpoint de
// preferências de usuário só para isto; localStorage já é o mecanismo usado
// para o próprio token de sessão neste projeto. Aplicado via classe `dark`
// na raiz do documento — Tailwind já está configurado com darkMode:["class"]
// e os componentes shadcn (Card, Dialog, Select, Tooltip, etc.) já usam os
// tokens de cor (bg-card, bg-popover, bg-background...) que essa classe
// sobrescreve em index.css; não inverte cores cruamente.
const THEME_KEY = "lootus-theme";

export function getStoredTheme() {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return v === "dark" || v === "light" ? v : null;
  } catch {
    return null;
  }
}

export function getInitialTheme() {
  const stored = getStoredTheme();
  if (stored) return stored;
  try {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
  try { localStorage.setItem(THEME_KEY, theme); } catch { /* navegação privada etc. — só não persiste */ }
}
